import { clsx } from 'clsx'

import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../../i18n/index.js'

interface Props {
  className?: string
}

export const AskAIDisclaimer = ({ className }: Props) => {
  return (
    <span
      className={clsx(
        'flex gap-1 items-baseline text-content-disabled text-xs my-2 ml-4',
        className,
      )}
    >
      <SvgIcon name="shield" size="md" />

      <T
        id="SmartSearch.AskAI.Disclaimer"
        defaultMessage="AI responses may contain errors. Your data stays private and isn’t shared with third-party AI models."
      />
    </span>
  )
}
